import React from "react";
import { Box, Theme, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Image from "../../Assets/assetHelper";
import DefaultBackground from "../../Assets/loginbackground.svg";
import KenColors from "../../Helpers/Themes/kenColors";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: "100%",
    minHeight: "100vh",
    width: "100%",
    overflow: "auto",
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundImage: `url(${DefaultBackground})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      opacity: 0.6,
      backgroundColor: theme.palette.KenColors.kenBlack,
      zIndex: 0,
    },
    [theme.breakpoints.down("md")]: {
      flexDirection: "column", // stack layout on mobile
      justifyContent: "center",
      alignItems: "center",
      padding: theme.spacing(2),
      "&::before": {
        opacity: 0.5, // keep background overlay visible but lighter
      },
    },
  },

  leftSection: {
    flex: 1,
    position: "relative",
    zIndex: 1,
    color: theme.palette.KenColors.kenWhite,
    paddingLeft: "14%",
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      display: "none", // hide left section on mobile
    },
  },

  logo: {
    height: 72,
    width: 72,
    objectFit: "cover",
    marginBottom: theme.spacing(2),
  },

  heading: {
    fontSize: "40px !important",
    fontWeight: "600 !important",
    fontFamily: "GeneralSans",
    color: theme.palette.KenColors.kenWhite,
    textTransform: "capitalize",
    marginBottom: theme.spacing(1),
  },

  layoutBar: {
    background: "#D77A36",
    height: 9,
    width: 98,
    margin: `${theme.spacing(1)} 0`,
  },

  subHeading: {
    fontSize: "16px !important",
    marginTop: "10px !important",
    fontWeight: 500,
    color: theme.palette.KenColors.kenWhite,
    width: "46%",
  },

  rightSection: {
    flex: 1,
    position: "relative",
    zIndex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingRight: "14%",
    minHeight: "100vh",
    [theme.breakpoints.down("md")]: {
      paddingRight: 0,
      width: "100%",
      padding: theme.spacing(2),
      minHeight: "100vh",
      justifyContent: "center",
      alignItems: "center",
    },
  },

  loginCard: {
    width: "90%",
    maxWidth: 700,
    height: "80vh",
    overflow: 'scroll',
    backgroundColor: "#fff",
    padding: theme.spacing(4),
    borderRadius: 8,
    boxShadow: theme.shadows[5],
    opacity: 0.95,
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "auto",
      boxShadow: "none",
      borderRadius: 8,
      opacity: 0.98,
      backgroundColor: "rgba(255,255,255,0.95)", // slightly transparent to show background
      padding: theme.spacing(3),
    },
  },

  formContainerLayout: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 2,
  },
}));

const AuthLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      {/* LEFT SIDE (hidden on mobile) */}
      <Box className={classes.leftSection}>
        <img
          src={Image.Images.DefaultOrganizationLogo}
          alt="logo"
          className={classes.logo}
        />
        <Typography className={classes.heading}>
          Stay Connected. <br />
          Grow Together.
        </Typography>
        <div className={classes.layoutBar} />
        <Typography className={classes.subHeading}>
          Join a Global Community of Learners, Educators, and Leaders Dedicated
          to Creating Impact Beyond Classrooms.
        </Typography>
      </Box>

      {/* RIGHT SIDE */}
      <Box className={classes.rightSection}>
        <Box className={classes.loginCard}>
          <Box className={classes.formContainerLayout}>{children}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AuthLayout;
